module.exports = __webpack_public_path__ + "static/UAmobSlide6-cd149f46c87ce86afe94291f9cedbc05.jpg";